import { DictionaryObject, useFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useExamTypes() {
  return useFetch<DictionaryObject[]>(`${EvidenceApiUrl.EXAM}/types/list`, {
    method: 'GET',
    cacheResponse: true,
  });
}
